export function generateSevenDayArray(startDate, endDate) {
    // Convert input dates to Date objects if they are not already
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Calculate the total difference in days
    const totalDays = Math.floor((end - start) / (1000 * 60 * 60 * 24));

    // Create an array to store the dates
    const datesArray = [];

    if (totalDays < 6) {
        // If total days are less than 6, fill the array with the end date as necessary
        for (let i = 0; i < 62; i++) {
            if (i <= totalDays) {
                // Add each day from start to end if within the total days range
                const currentDate = new Date(start.getTime() + i * 24 * 60 * 60 * 1000);
                datesArray.push(currentDate);
            } else {
                // Fill the remaining slots with the end date
                // datesArray.push(new Date(end));
            }
        }
    } else {
        // Calculate the interval in days
        const interval = totalDays / 6;
        
        // Generate the dates evenly spaced
        for (let i = 0; i < 62; i++) {
            const currentDate = new Date(start.getTime() + i * interval * 24 * 60 * 60 * 1000);
            datesArray.push(currentDate);
        }
    }

    return datesArray;
}


